module.exports = __webpack_public_path__ + "static/demilich-mtg_afr-70d493e70bca0796324fa753e3d1a46e.jpg";